import { Outlet, createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';

export const Route = createFileRoute('/_app/banks')({
  staticData: { crumb: 'nav.banks', crumbTo: '/banks', crumbParents: [{ crumb: 'nav.setup', to: '/setup' }] },
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'config.view', 'Setup'),
  component: Outlet,
});
